import { render } from "./Cards.vue?vue&type=template&id=4f30887a"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Cards.vue"]])

export default __exports__